import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../index';
import { handleNewActiveGameRoom } from '../Home/utils/helper';
var FavouritesExpired = /*#__PURE__*/function (_Component) {
  function FavouritesExpired() {
    var _this;
    _classCallCheck(this, FavouritesExpired);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FavouritesExpired, [].concat(args));
    _this.state = {
      message: QueryParamsProxy.findParam(RouteParamConstants.PARAM_MSG, null)
    };
    _this._buttonHandler = function () {
      var dismissModal = _this.props.dismissModal;
      dismissModal();
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MSG, null));
      handleNewActiveGameRoom(_this.props.navigation, Screens.VIP);
    };
    return _this;
  }
  _inherits(FavouritesExpired, _Component);
  return _createClass(FavouritesExpired, [{
    key: "render",
    value: function render() {
      return this.props.render({
        message: this.state.message,
        buttonHandler: this._buttonHandler
      });
    }
  }]);
}(Component);
export { FavouritesExpired as default };